import React, { Component } from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

// TODO: remove these inline styles
const styles = {
    buttonBasics: {
        display: 'inline-block',
        marginBottom: 0,
        verticalAlign: 'middle',
        whiteSpace: 'nowrap',
        fontWeight: '300',
        fontSize: '0.875em',
        letterSpacing: '0.05em',
        textTransform: 'uppercase',
        padding: '3.5px 10px 5.5px',
        width: '105px',
        textAlign: 'center',
        outline: 'none',
        borderWidth: '1px',
        borderStyle: 'solid',
    },
    buttonDisabled: {
        opacity: '0.5',
        borderColor: '#999',
        backgroundColor: '#999',
        color: 'white',
    },
};

export default class Button extends Component {
    static displayName = displayName('Dialog/Button');

    static propTypes = {
        children: PropTypes.any.isRequired,
        disabled: PropTypes.bool,
    };

    static defaultProps = {
        disabled: false,
    };

    render() {
        let styleList = {
            ...this.buttonStyles().normal,
            ...styles.buttonBasics,
        };

        if (this.props.disabled) {
            styleList = {
                ...styleList,
                ...styles.buttonDisabled,
                ...this.buttonStyles().disabled,
            };
        }

        return (
            <button style={styleList} {...this.props}>
                {this.props.children}
            </button>
        );
    }
}
